var map = {
	"./chat.svg": 6839,
	"./close.svg": 8179,
	"./icon-active.svg": 4725,
	"./icon-arrow-right.svg": 4091,
	"./icon-arrow.svg": 9482,
	"./icon-bump.svg": 2167,
	"./icon-check.svg": 2141,
	"./icon-create.svg": 7052,
	"./icon-exit.svg": 455,
	"./icon-order.svg": 173,
	"./icon-refresh.svg": 7260,
	"./icon-safety.svg": 5341,
	"./icon-tg.svg": 836,
	"./icon-x.svg": 5661,
	"./record.svg": 1214,
	"./refresh.svg": 5314,
	"./refresh1.svg": 9263,
	"./right.svg": 5605,
	"./sol.svg": 9585,
	"./title.svg": 129,
	"./top.svg": 406,
	"./trade-fail.svg": 1834,
	"./trade-success.svg": 7155,
	"./twitter.svg": 5562,
	"./xie.svg": 8485,
	"./xie2.svg": 7437
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2922;